export const serializedError = (err: any) => ({
    message: err?.response?.data?.message || err.message || "Failed to fetch question bank",
    status: err?.response?.status,
})
